import { getCookieValues } from './getCookieValues.js';
import { memoizedCookies } from './memoizedCookies.js';
const getCookie = ({ name, shouldMemoize = false }) => {
    const memoizedCookie = memoizedCookies.get(name);
    if (memoizedCookie) {
        return memoizedCookie;
    }
    const [value] = getCookieValues(name);
    if (value) {
        if (shouldMemoize) {
            memoizedCookies.set(name, value);
        }
        return value;
    }
    return null;
};
export { getCookie };
